<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-16 18:20:43
 * @FilePath: 
 * @Description: 业绩汇总
-->
<template>
  <div class="c-p-t-20 full_page_grey">
    <!-- <date-tab-com
      ref="dateTabRef"
      @change="handleChangeDateType"
      @changeDate="handleChangeDateData"
    ></date-tab-com> -->
    <ul class="statistics_item_con">
      <li v-for="(item, index) in functionList" :key="index">
        <p class="c-ft-24">{{ item.title }}</p>
        <div class="statistics_count_con">
          {{
            totalInfo[item.key] == 0 || totalInfo[item.key]
              ? totalInfo[item.key]
              : "--"
          }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
// import DateTabCom from "./comps/dateTabCom.vue";
import { getTotalPerformance } from "@/api/performance";
//按需引入
// let echarts = require("echarts/lib/echarts");
// require("echarts/lib/chart/line"); //线型图
// require("echarts/lib/component/tooltip"); //tooltip
// require("echarts/lib/component/legend"); //图例
// require("echarts/lib/component/grid"); //图例
export default {
  name: "TotalReport",
  props: {},
  data() {
    return {
      totalInfo: {},
      functionList: [
        // { title: "营业额", key: "BusinesTotal" },
        { title: "在场人数", key: "UnPayNumber" },
        { title: "上班预留", key: "ReserveNumber" },
        { title: "本班进店", key: "CheckinNumber" },
        { title: "本班离店", key: "CheckInoutNumber" },
      ],
    };
  },
  // components: { DateTabCom },
  created() {},
  mounted() {
    this.$nextTick(() => {
      // this.dateType = this.$refs.dateTabRef.nowDateType;
      this.handleGetTotalPerformance();
    });
  },
  methods: {
    // handleChangeDateType(type) {
    //   this.dateType = type;
    //   if (this.dateType !== 4) {
    //     this.handleGetTotalPerformance();
    //   }
    // },
    // handleChangeDateData(dateArr) {
    //   this.startDate = dateArr[0];
    //   this.endDate = dateArr[1];
    //   this.handleGetTotalPerformance();
    // },
    handleGetTotalPerformance() {
      const queryData = {
        Query: {
          // TimeType: this.dateType,
          // TimeType: 0,
          VpnId: this.$store.state.vpnId,
          IsOnlyTotal: true,
        },
      };
      // if (this.dateType == 4) {
      //   queryData.Query.BeginTime = this.startDate;
      //   queryData.Query.EndTime = this.endDate;
      // }
      getTotalPerformance(queryData).then((res) => {
        this.totalInfo = res;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.statistics_item_con {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  li {
    width: 48.5%;
    padding: 30px 0;
    border: 1px solid #eee;
    background: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    margin-bottom: 10px;
    &:nth-child(2n) {
      margin-right: 0;
    }
    .statistics_count_con {
      font-size: 30px;
      font-weight: bold;
      margin-top: 10px;
    }
  }
}
</style>
